/**
 * ============================================================
 * PORTAL LIFE
 * ============================================================
 */
const Life = {
    config: {
       /* apiUrl: "https://n8n.rhfranquias.com.br/webhook-test/504cb224-0fb1-4a40-8f9b-c2f03104e253" */
        apiUrl: "https://webhook.rhfranquias.com.br/webhook/504cb224-0fb1-4a40-8f9b-c2f03104e253" 
    },
    init() {
        console.log("Portal Life iniciado.");
        this.form = document.getElementById("lifeLoginForm");
        this.cpf = document.getElementById("lifeCpf");
        this.msg = document.getElementById("lifeMessage");
        if (!this.form || !this.cpf || !this.msg) {
            // Formulário Life não presente nesta página (ex: coleções, produto) — comportamento esperado
            return;
        }

        this.cpf.addEventListener("input", this.maskCPF);

        this.form.addEventListener("submit", (e) => {
            this.login(e);
        });

    },

    /**
     * Máscara CPF
     */
    maskCPF(e) {

        let value = e.target.value;

        value = value.replace(/\D/g, '');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d)/, '$1.$2');
        value = value.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

        e.target.value = value;

    },

    /**
     * Login
     */
    async login(e) {

        e.preventDefault();

        const cpf = this.cpf.value.replace(/\D/g, '');

        if (cpf.length !== 11) {

            this.showMessage("Informe um CPF válido.", "red");
            return;

        }

        this.showMessage("Consultando benefício...", "#555");

        console.log("CPF enviado:", cpf);

        try {

            const response = await fetch(this.config.apiUrl, {

                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify({
                    cpf: cpf
                })

            });

            console.log("Status:", response.status);

            const data = await response.json();

            console.log("data completo:", JSON.stringify(data));
            console.log("data.success:", data.success);
            console.log("data.session:", data.session);
            console.log("typeof data.success:", typeof data.success);

            console.log("Resposta do N8N:", data);

            if (!response.ok) {

                this.showMessage("Erro ao consultar benefício.", "red");
                return;

            }

           if (data.success) {

              // Salva a sessão no cookie
               this.setCookie("portal_session", data.session, 8);
              localStorage.setItem("life_session", JSON.stringify(data));

             // Salva a sessão nos cart attributes
              await fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
            attributes: {
               // 'life_session': data.session
               'life_session': JSON.stringify(data)
            }
        })
    });

          // Mensagem ao usuário
         this.showMessage("Verificação concluída. Redirecionando...", "green");

         // Aguarda 1 segundo e redireciona
        setTimeout(() => {
        window.location.href = "/collections/oculos-de-grau-1";
    }, 1000);

} else {

    this.showMessage(data.message || "Cliente não elegível.", "red");

}

        } catch (error) {

            console.error(error);

            this.showMessage("Erro ao conectar ao servidor.", "red");

        }

    },

    /**
     * Mensagens
     */
    showMessage(message, color) {

        this.msg.style.color = color;
        this.msg.innerHTML = message;

    },

    /**
     * Cookie
     */
    setCookie(name, value, hours) {

        const date = new Date();

        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));

        document.cookie =
            `${name}=${value}; expires=${date.toUTCString()}; path=/`;

    },

    /**
     * Ler Cookie
     */
    getCookie(name) {

        const cookieName = name + "=";

        const cookies = document.cookie.split(";");

        for (let cookie of cookies) {

            cookie = cookie.trim();

            if (cookie.indexOf(cookieName) === 0) {

                return cookie.substring(cookieName.length);

            }

        }

        return "";

    },

    /**
     * Desconto Life por tag de produto
     */
    getSession() {
        try {
            return JSON.parse(localStorage.getItem("life_session"));
        } catch {
            return null;
        }
    },

    async applyDiscount() {
        // Evita duplicar o monitoramento se o método for chamado novamente.
        if (this._lifeBenefitTimer) {
            clearInterval(this._lifeBenefitTimer);
        }

        

        const priceSelector = 'product-price';

        const getPriceBlocks = () => {
        const badge = document.getElementById('life-discount-badge');
        const section = badge?.closest('.shopify-section');

    if (section) {
        return section.querySelectorAll(priceSelector);
    }

    // Sem a seção identificada, atua somente se houver um único preço.
    const blocks = document.querySelectorAll(priceSelector);
    return blocks.length === 1 ? blocks : [];
};

    

        const originalStyles = new WeakMap();

        const restorePrices = () => {
            getPriceBlocks().forEach(block => {
                block.querySelectorAll('[data-life-zero-price]')
                    .forEach(node => node.remove());

                block.querySelectorAll('[data-life-original-price]')
                    .forEach(price => {
                        const savedStyle = originalStyles.get(price);

                        if (savedStyle == null) {
                            price.removeAttribute('style');
                        } else {
                            price.setAttribute('style', savedStyle);
                        }

                        price.removeAttribute('data-life-original-price');
                        originalStyles.delete(price);
                    });
            });
        };

        const updateBenefit = () => {
            const session = this.getSession();
            const cookieSession = this.getCookie('portal_session');
            const discount = Number(session?.regras?.desconto);

            const rawTags = window.lifeProductTags;
            const tags = Array.isArray(rawTags)
                ? rawTags.map(tag => String(tag).toLowerCase())
                : [];

            const rawLifeTags = session?.regras?.tags || ['life'];
            const lifeTags = Array.isArray(rawLifeTags)
                ? rawLifeTags.map(tag => String(tag).toLowerCase())
                : [];

            const activeSession = Boolean(
                session?.success &&
                session?.session &&
                cookieSession &&
                cookieSession === String(session.session)
            );

            const eligible = activeSession &&
                Number.isFinite(discount) &&
                discount > 0 &&
                tags.some(tag => lifeTags.includes(tag));

            const badge = document.getElementById('life-discount-badge');
            const msg = badge?.querySelector('.life-benefit-msg');

            if (badge && msg) {
                if (eligible) {
                    const name = session.cliente?.nome;
                    const greeting = name ? `${name}, ` : '';

                    msg.textContent =
                        `🎁 ${greeting}seu benefício Life está ativo, ` +
                        `${discount}% de desconto neste item!`;

                    msg.style.fontSize = '18px';
                    msg.style.fontWeight = '700';
                    msg.style.lineHeight = '1.4';
                    msg.style.textAlign = 'center';

                    badge.classList.remove('life-discount-badge--hidden');
                } else {
                    badge.classList.add('life-discount-badge--hidden');
                }
            }

            // Somente o benefício de 100% apresenta preço zero.
            if (!eligible || discount !== 100) {
                restorePrices();
                return;
            }

            getPriceBlocks().forEach(block => {

                const container = block.querySelector('[ref="priceContainer"]');
                const price = container?.querySelector('.price');

                if (!container || !price) return;

                // Guarda o estilo original sem substituir o valor do produto.
                if (!price.hasAttribute('data-life-original-price')) {
                    originalStyles.set(price, price.getAttribute('style'));
                    price.setAttribute('data-life-original-price', '');
                }

                price.style.textDecoration = 'line-through';
                price.style.opacity = '0.65';

                let zero = container.querySelector('[data-life-zero-price]');

                if (!zero) {
                    zero = document.createElement('span');
                    zero.setAttribute('data-life-zero-price', '');
                    zero.textContent = 'R$ 0,00';
                    zero.style.display = 'inline-block';
                    zero.style.marginInlineStart = '12px';
                    zero.style.fontWeight = '700';
                }

                // Reposiciona o zero se o tema atualizar o preço da variante.
                if (price.nextElementSibling !== zero) {
                    price.after(zero);
                }
            });
        };

        updateBenefit();

        // Acompanha expiração da sessão e atualizações do preço pelo tema.
        this._lifeBenefitTimer = setInterval(updateBenefit, 500);

    // Aplica discount code no carrinho via /discount/CODE
    const code = session.discount_code || '';
    if (!code) return;

    fetch(`/discount/${code}`, { method: 'GET', redirect: 'follow' })
        .then(() => console.log(`[Life] Discount ${code} aplicado ao carrinho`))
        .catch(err => console.warn('[Life] Erro ao aplicar discount:', err));

    // Monitora cliques em links de checkout
    document.addEventListener('click', (e) => {
        const btn = e.target.closest('a[href*="/checkout"], a[href*="/cart"]');
        if (!btn) return;
        const href = btn.getAttribute('href');
        if (href && href.includes('/checkout')) {
            e.preventDefault();
            window.location.href = `/checkout?discount=${code}`;
        }
    }, true);

},
    /**
     * Logout
     */
    
      logout() {
        document.cookie = "portal_session=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
        window.location.href = "/collections/oculos-de-grau-1";
    }

};

/**
 * Inicialização
 */
window.Life = Life;

/**
 * Fix: re-anima cards após filtro do Search & Discovery
 */
document.addEventListener('DOMContentLoaded', () => {
  const fixCards = () => {
    document.querySelectorAll('li.predictive-search-results__card').forEach(el => {
      el.style.opacity = '1';
      el.style.transition = 'opacity 0.3s ease';
    });
  };

  // Observa o body inteiro para garantir que pega qualquer mudança
  const observer = new MutationObserver(fixCards);
  observer.observe(document.body, { childList: true, subtree: true });

  // Também roda em popstate (navegação por URL do filtro)
  window.addEventListener('popstate', () => setTimeout(fixCards, 300));

  // Roda ao carregar também
  fixCards();
});
document.addEventListener("DOMContentLoaded", () => {
    Life.init();
    Life.applyDiscount();
});






